import { Navigate } from 'react-router-dom';
import { useSessionStorage } from '../../hooks';
import React, { useState, useEffect } from 'react';
import * as apiClient from "../../common/apiClient";
import {
  MainContainer
  , BoxContainer
  , Box
  , BoxLabel
  ,
  ScanContainer,
  ScanBox,
  Scan,
  ScanIcon,
  ScanDeviceRow,
  ScanDevice,
  CarHealthBad,
  DeviceId,
  Device,
  Content,
  ContentLabel,
  ContentValue,
  ContentIconContainer,
  ContentBox,
  ContentIcon,
  ContentRow,
  DeviceDeactive,
  DeviceRenew

} from './styled';
import Search_Icon from '../../assets/searchicon.svg';
import activedevice from '../../assets/activedevice.svg';
import calender from '../../assets/calender.svg';
import clock from '../../assets/clock.svg';
import technician from '../../assets/technician.svg';
import deactivedevice from '../../assets/deactivedevice.svg';




export const MyDevices = () => {
  const [authenticated, setAuthenticated] = useSessionStorage('authenticated');
  const [deviceData, setDeviceData] = useState([]);

  useEffect(() => {
    loadDevices();
    
  }, []);
  const loadDevices = () => {
    setDeviceData([]);
    apiClient.get(`devices/business_partner/${localStorage.getItem("business_partner_id")}`, null).then((response: any) => {
      setDeviceData(response)
      console.log(response)
    }).catch((err) => {

    })

  }
  const formatDate=(inputDate:any)=> {
    const date = new Date(inputDate);
    
    // Check if it's a valid date
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }
    
    const year = date.getFullYear();
    const month = date.toLocaleString('default', { month: 'short' });
    const day = date.getDate();
    if(year!=1970)
    {
      return `${day} ${month} ${year}`;
    }
    else
    {
      return `NA`;
    }
    
  }
  
  if (authenticated)
    return (
      <MainContainer>
        <BoxLabel>My Devices</BoxLabel>

        <ScanContainer>
          {deviceData.length > 0 && deviceData.map((item:any, index) =>

            <ScanBox>
              <Scan>
                <ScanDeviceRow>
                  <ScanDevice>
                    <Device> 
                      <div>Device </div>
 {/* {item.is_active==false?<DeviceDeactive>-Inactive</DeviceDeactive>:""} */}
{item.is_active==false?<DeviceRenew>Renew</DeviceRenew>:""}
                    </Device>
                    <DeviceId> {item.mac_address}</DeviceId>
                  </ScanDevice>
                  <ScanIcon>
                    <CarHealthBad src={item.is_active==true?activedevice:deactivedevice} />
                  </ScanIcon>
                </ScanDeviceRow>
                <ContentRow>
                  <ContentBox>
                    <ContentIconContainer>
                      <ContentIcon src={calender} />
                    </ContentIconContainer>
                    <Content>
                      <ContentLabel>Last Active </ContentLabel>
                    </Content>
                    <Content>
                      <ContentValue>{formatDate(item.last_active)} </ContentValue>

                    </Content>
                  </ContentBox>
                  <ContentBox>
                    <ContentIconContainer>
                      <ContentIcon src={clock} />
                    </ContentIconContainer>
                    <Content>
                      <ContentLabel>Valid  </ContentLabel>
                    </Content>
                    <Content>
                      <ContentValue>{formatDate(item.valid_till)} </ContentValue>

                    </Content>
                  </ContentBox>
                  <ContentBox>
                    <ContentIconContainer>
                      <ContentIcon src={technician} />
                    </ContentIconContainer>
                    <Content>
                      <ContentLabel>Assignee  </ContentLabel>
                    </Content>
                    <Content>
                      <ContentValue>Andrew</ContentValue>

                    </Content>
                  </ContentBox>

                </ContentRow>


              </Scan>


            </ScanBox>


          )}



        </ScanContainer>
      </MainContainer>


    );
  return <Navigate to='/' replace />;

};
